import { DropDownItem } from "@shared/classes/general";
import { Utilities } from "./utilities";
import { DriverDataBusinessType } from "@shared/enums";

export class BusinessHelper {
  static GetFullNameByFirstLastName(fullName: string, firstName: string, lastName: string) {
    if (!Utilities.isEmptyString(fullName)) {
      return fullName.trim();
    }

    if (Utilities.isEmptyString(firstName)) {
      return lastName?.trim();
    }

    if (Utilities.isEmptyString(lastName)) {
      return firstName?.trim();
    }

    return `${lastName.trim()}, ${firstName.trim()}`;
  }

  //#region business type
  static GetSeperatedBusinessTypeDropDownList() {
    var DropDownItems: DropDownItem[] = [];
    DropDownItems.push({ value: DriverDataBusinessType.LB, label: DriverDataBusinessType.LB });
    DropDownItems.push({ value: DriverDataBusinessType.MB, label: DriverDataBusinessType.MB });
    DropDownItems.push({ value: DriverDataBusinessType.PG, label: DriverDataBusinessType.PG });
    return DropDownItems;
  }

  static GetCombinedBusinessTypeDropDownList() {
    var DropDownItems: DropDownItem[] = [];
    DropDownItems.push({ value: DriverDataBusinessType.LB_MB, label: DriverDataBusinessType.LB_MB });
    DropDownItems.push({ value: DriverDataBusinessType.PG, label: DriverDataBusinessType.PG });
    return DropDownItems;
  }

  static GetSeperatedBusinessTypes(businessType: DriverDataBusinessType) {
    if (Utilities.isEmptyString(businessType)) {
      return [];
    }

    if (businessType === DriverDataBusinessType.LB_MB) {
      return [DriverDataBusinessType.LB, DriverDataBusinessType.MB];
    }

    return [businessType];
  }

  static GetCombinedBusinessType(businessTypes: DriverDataBusinessType[]) {
    if (!businessTypes || businessTypes.length === 0) {
      return "";
    }

    if (businessTypes.length === 2 && businessTypes.includes(DriverDataBusinessType.MB) && businessTypes.includes(DriverDataBusinessType.LB)) {
      return DriverDataBusinessType.LB_MB;
    }

    return businessTypes[0];
  }

  //#endregion business type
}
